import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'

// Connects to data-controller="rates-lookup"
export default class extends Controller {
  static targets = [
    'result', 'noResult', 'validResult', 'invalidResult', 'originCountryCode', 'originNumber',
    'destinationCountryCode', 'destinationNumber'
  ]

  async fetchRate(e) {
    e.preventDefault()

    const countryCode = e.target.value

    if (!countryCode) {
      this.noResultTarget.classList.remove('hidden')
      this.validResultTarget.classList.add('hidden')
      this.invalidResultTarget.classList.add('hidden')
      return
    }

    const response = await get(`/rates/${countryCode}`, {
      responseKind: 'turbo-stream'
    })

    if (response.ok) {
      this.noResultTarget.classList.add('hidden')
      this.validResultTarget.classList.remove('hidden')
      this.invalidResultTarget.classList.add('hidden')
    }
  }

  async fetchAdvancedRate(e) {
    e.preventDefault()

    const originCountryCode = this.originCountryCodeTarget.options[this.originCountryCodeTarget.selectedIndex].dataset.countryCode
    const destinationCountryCode = this.destinationCountryCodeTarget.options[this.destinationCountryCodeTarget.selectedIndex].dataset.countryCode

    if (this.originNumberTarget.value.length === 0 || this.destinationNumberTarget.value.length === 0) {

    }

    const originNumber = `+${originCountryCode}${this.originNumberTarget.value}`
    const destinationNumber = `+${destinationCountryCode}${this.destinationNumberTarget.value}`

    if (this.originNumberTarget.value.length === 0 || this.destinationNumberTarget.value.length === 0) {
      this.invalidResultTarget.classList.remove('hidden')
      this.noResultTarget.classList.add('hidden')
      this.validResultTarget.classList.add('hidden')
      return
    }

    const response = await get('/rate_matcher', {
      query: {
        origin: originNumber,
        destination: destinationNumber
      },
      responseKind: 'turbo-stream'
    })

    if (response.ok) {
      this.noResultTarget.classList.add('hidden')
      this.validResultTarget.classList.remove('hidden')
      this.invalidResultTarget.classList.add('hidden')
    } else {
      this.noResultTarget.classList.add('hidden')
      this.validResultTarget.classList.add('hidden')
      this.invalidResultTarget.classList.remove('hidden')
    }
  }
}
